import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./scheduledmeetings-grid-widget.html';
import _ from 'lodash';
import moment from 'moment-timezone';
import meetingsCommon from '../../../app/helpers/meetings-common';
import LoginService from "../../../services/login.service";


    function isValidDateRange(dateRange) {
        return moment(dateRange.startDate).isValid() && moment(dateRange.endDate).isValid();
    }

    function ScheduledMeetingsGridWidget(params) {
        var self = this;

        self.subscriptions = [];

        self.observableOptions = params.observableOptions;
        self.observableData = params.observableData;
        self.panelTemplate = params.panelTemplate;
        self.widgetSignals = params.widgetSignals;

        var data = self.observableData();
        self.typeaheadOptions = ko.observable(data.filters);
        self.selectedDateRangeValues = ko.observable(data.timeRange);

        self.timeZone = _.get(LoginService.userObject, 'timezoneDisplay', '');

        self.flexQueryOptions = ko.observable({
            WhereConditionObj: []
        });

        self.usersList = ko.observableArray();

        self.dateRangeOptions = {
            minDate: moment(),
            maxDate: moment().add(30, 'days')
        };

        self.assignedUserFilter = ko.observableArray();
        self.userFilterOptions = ko.observableArray();

        self.priorityFilterOptions = _.values(meetingsCommon.getMeetingPriorityMap());
        self.priorityFilter = ko.observableArray();

        var savedFilters = _.get(self.observableOptions(), 'filter', {});

        self.onDateRangeChange = function () {
            var options = self.observableOptions();
            var dateRange = self.selectedDateRangeValues();

            options.filter = options.filter || {};

            options.filter.dateRange = dateRange;

            self.observableOptions(options);
        };

        self.onFilterChange = function () {
            var newFilterValue = self.flexQueryOptions();
            var options = self.observableOptions();

            if (!options.filter) {
                options.filter = {};
            }

            options.filter.search = _.get(newFilterValue, 'WhereConditionObj[0].conditions', []);

            if (self.widgetSignals) {
                self.widgetSignals().dataRequested.dispatch();
            }

            self.observableOptions(options);
        };

        self.restorePrefs = function () {
            if (!_.isEmpty(savedFilters.search)) {
                self.flexQueryOptions({
                    WhereConditionObj: [{
                        conditions: savedFilters.search
                    }]
                });
            }

            if (!_.isEmpty(savedFilters.dateRange) && isValidDateRange(savedFilters.dateRange)) {
                self.selectedDateRangeValues(savedFilters.dateRange);
            }

            if (!_.isEmpty(savedFilters.priority)) {
                self.priorityFilter(savedFilters.priority);
            }

            if (!_.isEmpty(savedFilters.assignees)) {
                self.assignedUserFilter(savedFilters.assignees);
            }
        };

        self.subscriptions.push(self.assignedUserFilter.subscribe(function (assignees) {
            var options = self.observableOptions();

            if (!options.filter) {
                options.filter = {};
            }

            if (!_.isEqual(options.filter.assignees, assignees)) {
                options.filter.assignees = assignees;
                self.observableOptions(options);
            }

        }));

        self.subscriptions.push(self.priorityFilter.subscribe(function (priority) {
            var options = self.observableOptions();

            if (!options.filter) {
                options.filter = {};
            }

            if (!_.isEqual(options.filter.priority, priority)) {
                options.filter.priority = priority;
                self.observableOptions(options);
            }
        }));

        self.userOptions = {
            includeSelectAllOption: true,
            nonSelectedText: "Assigned User: (All)",
            nSelectedPrefix: 'Asssgnees: ',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            buttonWidth: 180,
            maxHeight: 400
        };

        self.priotityOptions = {
            includeSelectAllOption: true,
            nonSelectedText: "Priority: (All)",
            allSelectedText: 'Priority: (All)',
            buttonWidth: 135,
        };

        self.subscriptions.push(self.flexQueryOptions.subscribe(self.onFilterChange));
        self.subscriptions.push(self.selectedDateRangeValues.subscribe(self.onDateRangeChange));
        self.subscriptions.push(self.observableData.subscribe(self.RefreshData.bind(self)));

        self.RefreshData();
        self.restorePrefs();
    }

    ScheduledMeetingsGridWidget.prototype.RefreshData = function () {
        var self = this;

        var data = self.observableData();
        var options = self.observableOptions();

        self.usersList(data.usersList);

        self.userFilterOptions(_.sortBy(data.usersList, 'name'));
        self.assignedUserFilter(_.get(options, 'filter.assignees'));
        self.typeaheadOptions(data.filters);
    };

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    ScheduledMeetingsGridWidget.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default {
        viewModel: ScheduledMeetingsGridWidget,
        template: templateMarkup
    };
